module.exports = __webpack_public_path__ + "static/media/soundon.fd2bdde6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soundon.svg
// module id = 613
// module chunks = 0